import React from 'react';
import './terms.css';

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last Updated: December 2023</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using Ernestic Fashion's services, you agree to be bound by these Terms of Service 
              and our Privacy Policy. If you disagree with any part of these terms, you may not access our services.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Services Description</h2>
            <p>Ernestic Fashion provides:</p>
            <ul>
              <li>Bespoke clothing design and tailoring services</li>
              <li>Ready-to-wear fashion collections</li>
              <li>Personal styling consultations</li>
              <li>Custom fabric selection and design</li>
              <li>Virtual fitting and measurement services</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. User Accounts</h2>
            <p>When you create an account with us, you must:</p>
            <ul>
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your password</li>
              <li>Notify us immediately of any unauthorized use</li>
              <li>Be at least 18 years old or have parental consent</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Orders and Payments</h2>
            <h3>4.1 Custom Orders</h3>
            <p>
              Bespoke items require detailed measurements and specifications. Once production begins, 
              custom orders cannot be cancelled as they are made specifically for you.
            </p>
            
            <h3>4.2 Payment Terms</h3>
            <ul>
              <li>Full payment is required for ready-to-wear items</li>
              <li>Custom orders require a 50% deposit with balance due before shipping</li>
              <li>We accept major credit cards and secure payment methods</li>
              <li>Prices are subject to change without notice</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Shipping and Delivery</h2>
            <ul>
              <li>Standard shipping: 3-5 business days</li>
              <li>Express shipping: 1-2 business days</li>
              <li>Custom items: 4-6 weeks production time</li>
              <li>International shipping available with additional fees</li>
              <li>You are responsible for any customs duties and taxes</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Returns and Exchanges</h2>
            <h3>6.1 Ready-to-Wear</h3>
            <ul>
              <li>30-day return policy for unworn items with tags</li>
              <li>Items must be in original condition</li>
              <li>Return shipping costs are the customer's responsibility</li>
            </ul>

            <h3>6.2 Custom/Bespoke Items</h3>
            <p>
              Due to the personalized nature of bespoke clothing, custom items cannot be returned 
              or exchanged unless there is a manufacturing defect.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Intellectual Property</h2>
            <p>
              All content on our platform, including designs, logos, text, and images, are the 
              property of Ernestic Fashion and protected by copyright laws. You may not use our 
              intellectual property without written permission.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Limitation of Liability</h2>
            <p>
              Ernestic Fashion shall not be liable for any indirect, incidental, special, or 
              consequential damages resulting from the use or inability to use our services.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Governing Law</h2>
            <p>
              These Terms shall be governed by the laws of the State of Delaware, without regard 
              to its conflict of law provisions.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Continued use of our services 
              after changes constitutes acceptance of the modified terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Contact Information</h2>
            <div className="contact-info">
              <p>Ernestic Fashion Customer Service</p>
              <p>Email: legal@ernesticfashion.com</p>
              <p>Phone: +1 (555) 123-ERNESTIC</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;